import { sumArray } from 'commons/utils/array'
import { convertBooleanApiValue } from 'commons/utils/string'
import { TypesValidations } from 'constants/enums'
import STATUS from 'constants/statusRascunho'
import type { MaterialsListInterface } from 'store/SalesOrderContext/types/MaterialItemData'

import type { Material, SimulateDraft } from '../interfaces'

export const haveMaterialAvailable = (materials: Array<Material>): boolean => {
  const validateAvailability = materials.some(
    (material) =>
      material.stat === STATUS.WITHOUT_QUOTA ||
      material.stat === STATUS.OUT_MINIMUM_ORDER ||
      material.stat === STATUS.OUT_OF_STOCK ||
      material.cores.some((cor) =>
        cor.tamanhos.some(
          (size) => size.fl_cota === TypesValidations.NO && size.fl_estq === TypesValidations.NO,
        ),
      ),
  )

  return validateAvailability
}

export const isProceedDisabled = (data: SimulateDraft) => {
  const hasSomeMaterialAvailable = data.materiais.some(
    (material) => material.stat === STATUS.ANSWERED,
  )
  return !hasSomeMaterialAvailable
}

export const getPendingRecords = (records: MaterialsListInterface[]) =>
  records.filter(
    (record) => record.cd_stat_pedi_rasc_item === 0 || record.cd_stat_pedi_rasc_item === 20,
  )

export const getSelectedRecords = (records: MaterialsListInterface[]) =>
  records.filter(
    (item: MaterialsListInterface) =>
      (item.cd_stat_pedi_rasc_item === 0 || item.cd_stat_pedi_rasc_item === 20) &&
      convertBooleanApiValue(item.fl_sele),
  )

export const calcPars = (records: MaterialsListInterface[]) => {
  const selectedPairs = getSelectedRecords(records).map((item: MaterialsListInterface) => {
    return item.qt_tota_item_conv
  })
  return selectedPairs.reduce(sumArray, 0)
}
export function verifyIfIsClosedBox(v: MaterialsListInterface) {
  const isGrade = /\D/g.test(v.tamanhos[0].cd_tamh)
  return !isGrade
}
export const calcTotal = (records: MaterialsListInterface[]) => {
  const items: MaterialsListInterface[] = getSelectedRecords(records)
  const valuesToSum = items.map((item: MaterialsListInterface) => item.vl_tota_item || 0)

  return valuesToSum.reduce(sumArray, 0)
}
